import React from 'react';
import {Field, Formik} from "formik";
import BootstrapLoadingButton from "../../Ui/BootstrapLoadingButton";
import TextField from "../../Ui/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import * as Yup from 'yup';

export default function (props) {

    const {hasSociete, onSubmit, onUpdate, initialValues, modelUnderEdition} = props;

    const validationSchema = React.useMemo(() => {

        if (hasSociete)
            return Yup.object().shape(
                {
                    libelle: Yup.string().required('Vous devez saisir le libelle'),
                    societe: Yup.string().required('Vous devez saisir la societé')
                });

        return Yup.object().shape(
            {
                libelle: Yup.string().required('Vous devez saisir le libelle')
            }
        )


    }, [hasSociete])

    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            onSubmit={(values, formikHelpers) => {

                if (onSubmit && !modelUnderEdition)
                    onSubmit(values, formikHelpers)

                else if (onUpdate && modelUnderEdition)
                    onUpdate(values, formikHelpers)


            }}
            validationSchema={
                validationSchema
            }
        >
            {
                (formikHelpers) => {

                    return (
                        <div className={'row align-items-center'}>

                            <div className={'col'}>

                                <Field
                                    name={'libelle'}
                                    label={'Libelle'}
                                    component={TextField}
                                />

                            </div>

                            {
                                hasSociete && (
                                    <div className="col">

                                        <Field
                                            name={'societe'}
                                            label={'Societé'}
                                            component={TextField}
                                            select
                                        >

                                            <MenuItem value={'cie'}>CIE</MenuItem>
                                            <MenuItem value={'sodeci'}>SODECI</MenuItem>

                                        </Field>

                                    </div>
                                )
                            }

                            <div className="col-auto">
                                {
                                    !modelUnderEdition && (

                                        <BootstrapLoadingButton
                                            isLoading={formikHelpers.isSubmitting}
                                            onClick={formikHelpers.submitForm}
                                            className={'btn btn-secondary py-3'}>
                                            Ajouter
                                        </BootstrapLoadingButton>

                                    )
                                }

                                {
                                    modelUnderEdition && (

                                        <BootstrapLoadingButton
                                            isLoading={formikHelpers.isSubmitting}
                                            onClick={formikHelpers.submitForm}
                                            className={'btn btn-light-success py-3'}>
                                            Modifier
                                        </BootstrapLoadingButton>

                                    )
                                }
                            </div>

                        </div>
                    );

                }
            }
        </Formik>
    )

}